import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useHistory, useLocation} from 'react-router-dom';
import {Icon} from 'front-onceforall-core';
import {USER_REQUEST_TYPES} from '../../utils/constant';

function MessageInfoView({message, requestType}) {
  const history = useHistory();
  const location = useLocation();

  const handleOpenContactModal = event => {
    event.preventDefault();
    event.stopPropagation();
    history.push(`${location.pathname}?contact=${requestType}`);
  };

  return (
    <div
      className="box primary flex-container p-4 mb-5"
      data-id="info-box"
    >
      <span style={{flexShrink: 0}}>
        <Icon
          icon="info"
          size={20}
        />
      </span>
      <span>
        <Translate value={message}/>&nbsp;
        <a
          onClick={handleOpenContactModal}
          href="#"
        >
          <Translate value="organisationSetting.contactCustomerService"/>
        </a>
      </span>
    </div>
  );
}

MessageInfoView.defaultProps = {
  requestType: USER_REQUEST_TYPES.MY_SETTINGS
};

MessageInfoView.propTypes = {
  message: PropTypes.string.isRequired,
  requestType: PropTypes.string
};

export default MessageInfoView;
